<div class="row ">
    <div class="col-md-12">
        <span *ngIf="!vm.rowsFiltered?.length">No data found at the moment!</span>

        <table *ngIf="vm.rowsFiltered.length" mdbTable mdbTableScroll scrollY="true" maxHeight="{{tableMaxHeight}}" striped="true" small="true"
                        style="table-layout: fixed">
            <thead>
                <tr>
                    <th scope="col" *ngFor="let c of vm.data.columns" style="font-size: small;"><strong>{{c}}</strong>
                    </th>
                    <th *ngIf="includeAction || vm.showActionColumn" style="font-size: small;"><strong>Actions</strong></th>
                </tr>
            </thead>
            <tbody>
                <tr mdbTableCol *ngFor="let r of vm.rowsFiltered; index as i">
                    <td *ngFor="let f of r.fields; index as fi" style="font-size: small;">
                        <div *ngIf="f && isContainArray(f, '|')">
                            <div *ngFor="let f2 of f.split('|')">
                                {{f2}}<br />
                            </div>
                        </div>
                        <div *ngIf="f && !isContainArray(f, '|')">{{f}}</div>
                    </td>
                    <td *ngIf="r.actions && r.actions.length">
                        <div *ngFor="let a of r.actions">
                            <a class="underlined pl-3" href="javascript:null"
                                (click)="onRowActionClick(vivm, r.code, a.code)">
                                {{a.name}}
                            </a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>